// Action creators

export const logoutUser = () => ({
  type: 'LOGOUT_USER'
})


// WEBPACK FOOTER //
// ./src/actions/logout_actions.js